import React from "react";
import ReactDOM from "react-dom/client";
import { setupAuthFetch } from "./setupAuthFetch";
import App from "./App";

setupAuthFetch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
